module.exports = [
  {
    "description": "If you're unemployed or your income has decreased, you may benefit from this state program that will pay your monthly mortgage for a period of time.",
    "key": "1",
    "name": "Monthly Payment Assistance"
  },
  {
    "description": "You may be eligible for a program where funds can be used to pay your delinquent amount and/or make a contribution toward your unpaid principal balance in order to modify your loan and provide a more affordable payment.",
    "key": "2",
    "name": "Loan Modification"
  },
  {
    "description": "If you're behind on your mortgage payments, you may qualify for a one-time contribution to help make your mortgage more current and prevent foreclosure.",
    "key": "3",
    "name": "Reinstatement"
  },
  {
    "description": " You may be eligible for a state program which provides financial assistance to help pay down the principal balance of your mortgage loan and helps you qualify for a loan modification. ",
    "key": "4",
    "name": "Principal Reduction"
  },
  {
    "description": "You may be eligible for a state program that assists homeowners who are transitioning out of their homes via the Deed-in-Lieu or Short Sale process into more affordable housing. ",
    "key": "5",
    "name": "Transition Assistance"
  },
  {
    "description": "If you have a second lien mortgage you may be eligible for a state program which would assist by eliminating the second mortgage delinquency in order to modify the terms of the primary loan and achieve affordability.",
    "key": "6",
    "name": "Second Lien Mortgage Assistance"
  },
  {
    "description": "If you owe property taxes to the county or local municipality you may qualify for funds which would assist in preventing property tax foreclosure.",
    "key": "7",
    "name": "Lien Extinguishment"
  }
]



//////////////////
// WEBPACK FOOTER
// ./test/testPrograms.js
// module id = 24
// module chunks = 0